import { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { Divider } from "antd"

// Utils
import { get } from "library/endpoints"

import Entry from './entry';


const List = (props) => {
  const [entries, setEntries] = useState([])

  useEffect(() => {
    fetchData();
  }, [])

  const fetchData = async () => {
    try {
      const response = await get(`/frontend/help-desk`)
      setEntries(response.data)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <Divider>Mes tickets</Divider>
      
      {
        entries.map((entry) => (
          <Entry 
            key={`helpdesk-entry-${entry._id}`}
            entry={entry}
          />
        ))
      }
    </>
  )
}

export default withTranslation()(List)